import type { TimelineBoardKey } from '../../types/schema'
import type { TimelineElement } from '../../types/timelineElement'
import type { AiOperationTargetRef } from '../../types/aiOperational'
import { isEditableTarget, type EditTarget } from './editTarget'

/**
 * Maps an EditTarget to an AiOperationTargetRef for operational execution.
 *
 * Notice: For checklist items (kind: 'checklist_item'), the operational target type
 * is 'CHECKLIST' as defined in src/types/aiOperational.ts:139 ('CHECKLIST_ITEM' does not exist).
 */
export const toOperationalTargetRef = (
  target: EditTarget,
  boardElements: readonly TimelineElement[] = [],
  activeBoard: TimelineBoardKey = 'VISIONBOARD',
): AiOperationTargetRef | null => {
  if (!isEditableTarget(target)) return null
  const id = target.kind === 'goal'
    ? target.goalId
    : target.kind === 'task'
      ? target.taskId
      : target.kind === 'subtask'
        ? target.subTaskId
        : target.itemId
  const element = boardElements.find((candidate) => candidate.id === id)
  return {
    id,
    type: target.kind === 'goal'
      ? 'GOAL'
      : target.kind === 'task'
        ? 'TASK'
        : target.kind === 'subtask'
          ? 'SUBTASK'
          : 'CHECKLIST',
    title: target.label,
    board: element?.board ?? activeBoard,
    parentId: element?.parentId ?? (target.kind === 'checklist_item' ? (target.subTaskId ?? target.taskId) : null),
  }
}
